import router from 'next/router';
import fetchNext from '@features/api/fetchNext';
import getPublicEnv from '@utils/getPublicEnv';
import { TUserOrderType } from '@features/userPanel/typescript';
class NextReturnsApi {
  private endpoints = {
    lookupOrder: () => `return-request/lookup`
  };
  private static getLocale() {
    const isServerSide = typeof window === 'undefined';
    if (isServerSide) return process.env.DEFAULT_LOCALE;
    const {
      locale
    } = router;
    return locale || getPublicEnv('NEXT_PUBLIC_DEFAULT_LOCALE');
  }
  public async lookupOrder(data: {
    orderNumber: string;
    email: string;
  }) {
    const method = 'POST';
    const {
      json
    } = await fetchNext(this.endpoints.lookupOrder(), {
      method,
      body: JSON.stringify({
        orderNumber: data.orderNumber,
        email: data.email
      })
    }, NextReturnsApi.getLocale());
    return json as {
      success?: boolean;
      data?: TUserOrderType;
      error?: boolean;
      status?: number;
      message?: string;
    };
  }
}
export default new NextReturnsApi();